import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { ReviewAutomationOverlayComponent } from '../automation-overlay/review-automation-overlay.component'
import { AmplitudeService } from '@tv3/services/amplitude.service'

@Component({
  selector: 'app-review-automations-overlay',
  templateUrl: './review-automations-overlay.component.html',
  styleUrls: ['./review-automations-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ReviewAutomationsOverlayComponent implements OnInit {
  constructor(
    private dialog: DialogService,
    public dialogRef: MatDialogRef<ReviewAutomationsOverlayComponent>,
    private amplitudeService: AmplitudeService
  ) {}

  ngOnInit(): void {
    this.amplitudeService.logEvent('review-automations-overlay-view')
  }

  onAddAutomation() {
    this.amplitudeService.logEvent('review-automations-overlay-add')
    this.dialog.openDrawer(ReviewAutomationOverlayComponent, {
      panelClass: 'drawer-full-80',
    })
  }
  close() {
    this.amplitudeService.logEvent('review-automations-overlay-close')
    this.dialogRef.close()
  }
}
